module.exports = __webpack_public_path__ + "static/media/index_30.3a49724f.jpg";